(($, Drupal) => {
  Drupal.behaviors.changeThis = {
    attach(settings, context) {
      $('.user-register-form .form-item-pass-pass1').find('input').keyup(function(){
        if( $(this).val().length) {
          $('.password-suggestions').show();
          $('.password-strength').show();
        } else {
          $('.password-suggestions').hide();
          $('.password-strength').hide();
        }
        if ($('.password-suggestions ul li').text() == "") {
          $('.password-suggestions').hide();
        } else {
          if( $(this).val().length) {
            $('.password-suggestions').show();
            $('.password-strength').show();
          }
        }
      });
  
      $('.user-register-form .form-type-password').find('input').keyup(function(){
        $('.password-suggestions').show();
        if ($('.password-suggestions ul li').text() == "") {
          $('.password-suggestions').hide();
        } else {
          $('.password-suggestions').show();
        }
      });
      if ($('.otp-registration-form').length) {
        if (!$('.otp-container').hasClass('hidden')) {
          $('#block-backbeaver-theme-socialauthlogin').hide();
        }
      }
    },
  };
})(jQuery, Drupal);
